// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { mainBuildEnv } from "./utils/runtimeEnv";

export const MAIN_BUILD_ENV: Record<string, string> = Object.fromEntries(
  Object.entries(mainBuildEnv).filter(([, value]) => typeof value === "string"),
) as Record<string, string>;
